
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
          <v-row class="d-flex justify-center mt-3">
              <v-col cols="4">
                  <v-text-field
                  label="Ano/Série"
                  v-model="form.filters.anoSerie"
                  outlined
                  dense
                  ></v-text-field>
              </v-col>
              <sca-select-ativo
                :cols="2"
                :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
                v-model="form.filters.situacao"
              ></sca-select-ativo>
              <sca-date-picker
              :cols="2"
              label="Data Início"
              v-model="form.filters.dataInicio"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
            <sca-date-picker
            :cols="2"
              v-model="form.filters.dataFim"
              label="Data Final"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
          </v-row>
           <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarRelatorios"
            ></sca-tooltip>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        :headers="headersAnalitico"
        :items="form.lists.listRelatorios"
        :items-per-page="10"
        :footer-props="$footerProps"
        show-expand
        sort-by="dataAcao"
        :sort-desc="true"
        :expanded.sync="expanded"
      >
        <template v-slot:[`item.anoSerie`]="{ item }">
          {{ item.anoSerie }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="resposta" :colspan="headers.length">
            <div class="resposta-conteudo">
              {{ item.alunos.nome }}
            </div>
          </td>
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.situacao" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.dataAcao`]="{ item }">
          {{ $formatarDataHora(item.dataAcao) }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="form.lists.listRelatorios.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorioPdf"
        @cancel="baixarCSVRelatorio"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
  import pageLoadingMixin from "mixins/page-loading.mixin";
  import RelatorioDeLog from "~/services/relatorios-log/manter-ano-serie-log.service"
  export default {
      name: "RelatorioLogAnoSerie",
      mixins: [pageLoadingMixin, RelatorioDeLog],

      data: () => ({
      onReport: false,
      expanded: [],
      form: {
          filters: {
              anoSerie: null,
              situacao: null,
              dataInicio: null,
              dataFim: null,
          },
          lists: {
              listRelatorios: [],
          },
      },
      headersAnalitico: [
          { text: "Ano/Série", align: "center", value: "anoSerie" },
          { text: "O que se espera do aluno", align: "center", value: "data-table-expand"},
          { text: "Situação", align: "center", value: "situacao" },
          { text: "Data/Hora da ação", align: "center", value: "dataAcao" },
          { text: "Ação", align: "center", value: "acao" },
      ],
      }),
      methods: {
      async buscarRelatorios() {
          const isValid = this.validarDatas();
          if (!isValid) return;
          if (!this.verificarFiltrosPreenchidos()) return;
          this.showPageLoading();
          try {
          const { data } = await this.$obterRelatorioLogAnoSerie({ params: this.form.filters });
          this.processarRespostaRelatorio(data);
          } finally {
          this.hidePageLoading();
          }
      },
      validarDatas() {
      const { dataInicio, dataFim } = this.form.filters;

      if (dataInicio && dataFim) {
        if (new Date(dataFim) < new Date(dataInicio)) {
          this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
          return false;
        }
        if (new Date(dataInicio) > new Date(dataFim)) {
          this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
          return false;
        }
      }
      return true;
    },

    verificarFiltrosPreenchidos() {
      const { anoSerie, situacao, dataInicio, dataFim } = this.form.filters;
      if (!anoSerie && situacao == null && !dataInicio && !dataFim) {
        this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
        return false;
      }
      return true;
    },

      async baixarCSVRelatorio() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogCSVAnoSerie({ params: this.form.filters });
        this.$baixarRelatorioCSV(data, `SCA.RelatórioDeLogDeAnoSérieCSV`);
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      async baixarRelatorioPdf() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogPDFAnoSerie({ params: this.form.filters });
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SCA.RelatórioDeLogDeAnoSérie.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      processarRespostaRelatorio(data) {
        this.form.lists.listRelatorios = data.lista;
      },

      resetForm() {
        this.form.filters.dataInicio = null;
        this.form.filters.dataFim = null;

        this.$nextTick(() => {
          this.$set(this.form.filters, 'dataInicio', null);
          this.$set(this.form.filters, 'dataFim', null);
        });
        this.form.filters.anoSerie = null;
        this.form.filters.situacao = null;

        this.form.lists.listRelatorios = [];
        this.expanded = [];
      }
    },
  };
</script>
<style scoped>
  .resposta {
    padding: 1em !important;
    text-align: left;
  }

  .resposta-conteudo {
    font-weight: bold;
    padding: 0.8rem;
    border-radius: 3px;
    line-height: 1.4;
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    max-width: 100%;
    font-size: 0.95rem;
    margin: 0.5rem 0;
  }
</style>
